module.exports = __webpack_public_path__ + "img/线3.838eebca.svg";